import { useTranslation } from 'react-i18next';
import Input from "../Input";
import * as S from "./styles";

const SearchBar = ({
  searchQuery,
  setSearchQuery,
  placeholder = "Pesquisar uma conversa",
  cancelText
}) => {
  const { t } = useTranslation('common');
  const resolvedCancelText = cancelText ?? t('buttons.cancel');
  // Apenas prevenir reload da página no submit (Enter)
  const handleSubmitSearch = event => {
    event.preventDefault();
    // Não faz nada - a busca acontece em tempo real via onChange
  };

  return (
    <S.Wrapper>
      <form onSubmit={handleSubmitSearch}>
        <Input
          type="text"
          onChange={({ target }) => setSearchQuery(target.value)}
          value={searchQuery}
          placeholder={placeholder}
        />
        {searchQuery!=="" &&
          <div style={{display:'flex', justifyContent:'end'}}>
            <span style={{fontSize:13, paddingTop:5, cursor:'pointer'}} onClick={() => setSearchQuery("")}>{resolvedCancelText}</span>
          </div>
        }
      </form>
    </S.Wrapper>
  );
};

export default SearchBar;
